

import { GET_QUOTE_LIST_SUCCESS, GET_QUOTE_SETTING_LIST_SUCCESS, GET_DIRECT_DEBIT_CONFIGURATION_SUCCESS, UPDATE_QUOTE_OPERATION_DATA, UPDATE_GENERATED_PAYMENT_REF } from "../action-types/quote";
import QuoteService from "../services/quote";

// *******************************
//  GET QUOTE LIST
// *******************************

export const getQuoteList = (associateId) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        QuoteService.getQuoteList(associateId)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getQuoteListSuccess(response));
        })
        .catch(error => {
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getQuoteListSuccess = (quotes) => {
    return  {
        type: GET_QUOTE_LIST_SUCCESS,
        quotes: quotes
    };
}

// ***************************************
//  GET QUOTE DEBIT DIRECT CONFIGURATION
// ***************************************

export const getQuoteDebitDirectConfiguration = (associateId) => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        QuoteService.getQuoteDebitDirectConfiguration(associateId)
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getQuoteDebitDirectConfigurationSuccess(response));
        })
        .catch(error => {
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getQuoteDebitDirectConfigurationSuccess = (directDebit) => {
    return  {
        type: GET_DIRECT_DEBIT_CONFIGURATION_SUCCESS,
        directDebit: directDebit
    };
}

// *******************************
//  GET QUOTE SETTINGS LIST
// *******************************

export const getQuoteSettingList = () => {
    return dispatch => {
        //dispatch(setAppLoading(true));

        QuoteService.getQuoteSettingList()
        .then((response) => {
            //dispatch(setAppLoading(false));
            dispatch(getQuoteSettingListSuccess(response));
        })
        .catch(error => {
            //dispatch(setAppLoading(false));
            //dispatch(appError("general.popup-messages.admin.get-group-list-error"));
        });
    };
}

export const getQuoteSettingListSuccess = (settings) => {
    return  {
        type: GET_QUOTE_SETTING_LIST_SUCCESS,
        settings: settings
    };
}

// *******************************
//  UPDATE QUOTE OPERATION DATA
// *******************************

export const updateQuoteOperationData = (data) => {
    return  {
        type: UPDATE_QUOTE_OPERATION_DATA,
        operation: data
    };
}

// *******************************
//  UPDATE GENERATED PAYMENT REF
// *******************************

export const updateGeneratedPaymentRef = (paymentRef) => {
    return  {
        type: UPDATE_GENERATED_PAYMENT_REF,
        paymentRef: paymentRef
    };
}